import { Injectable, signal } from '@angular/core';
import { ToastMessage, ToastVariant } from '../models/toast-message';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toastState = signal<ToastMessage | null>(null);
  private timeoutId?: ReturnType<typeof setTimeout>;
  private nextId = 0;

  readonly toast = this.toastState.asReadonly();

  success(header: string, subheader?: string): void {
    this.show(header, subheader, 'success');
  }

  error(header: string, subheader?: string): void {
    this.show(header, subheader, 'error', 8000);
  }

  warning(header: string, subheader?: string): void {
    this.show(header, subheader, 'warning');
  }

  information(header: string, subheader?: string): void {
    this.show(header, subheader, 'information');
  }

  clear(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }

    this.toastState.set(null);
  }

  private show(
    header: string,
    subheader: string | undefined,
    variant: ToastVariant,
    duration = 5000,
  ): void {
    this.clear();
    this.nextId += 1;

    this.toastState.set({
      id: `clockload-toast-${this.nextId}`,
      header,
      subheader,
      variant,
    });

    this.timeoutId = setTimeout(() => {
      this.toastState.set(null);
      this.timeoutId = undefined;
    }, duration);
  }
}
